import React from "react";

//import logo from "./logo.svg";
//import "./App.css";

import Select from "react-select";
import { getHost } from "./utils";
import SelectPopup from "./components/SelectPopup";
import OptionDisplay from "./components/OptionDisplay";
import ShippingDisplay from "./components/ShippingDisplay";
import ShipDisplay from "./components/ShipDisplay";
import FlightDisplay from "./components/FlightDisplay";
import InfoPopupHover from "./components/InfoPopupHover";
//import settings from "./settings.json";

import queryString from "query-string";

import moment from "moment";

if (!window.configData?.AGENCYID) {
  window.configData = {
    AGENCYID: "2d03fadb-c6a9-46e0-a425-8103afa0004d",
    REF: "2639",
    //CRUISEURL: "https://test2.xtibe.de/de?ref=24182",
    CRUISEURL: "https://kreuzfahrt.burgdorfer-reisecenter.de/",
  };
}

let defaultCruise = {
  value: "NS",
  label: "Hochsee (ohne Flug)",
};

let defaultRiverCruise = { value: "R", label: "Fluss" };

const parsed = queryString.parse(document.location.search, {
  arrayFormat: "index",
});

function App() {
  const [data, setData] = React.useState({});

  const [searchVisible, setSearchVisible] = React.useState(true);

  //console.log(settings);
  const [selectedShippingCompany, setSelectedShippingCompany] = React.useState(
    []
  );

  const [startSearch, setStartSearch] = React.useState(false);
  const [dur, setDur] = React.useState("");
  const [sort, setSort] = React.useState("");
  const [sdat, setSdat] = React.useState("");
  const [bdat, setBdat] = React.useState("");
  const [sdatDate, setSdatDate] = React.useState(null);
  const [bdatDate, setBdatDate] = React.useState(null);
  const [selectedRegion, setSelectedRegion] = React.useState([]);
  const [selectedShip, setSelectedShip] = React.useState([]);
  const [selectedType, setSelectedType] = React.useState(defaultCruise);
  const [p, setP] = React.useState("2");
  const [cruiseid, setCruiseid] = React.useState("");
  const [hmi, setHmi] = React.useState([]);
  const [dsi, setDsi] = React.useState([]);
  //console.log(data);

  let types = [
    { value: "K", label: "Hochsee" },
    { value: "NS", label: "Hochsee (ohne Flug)" },
    { value: "S", label: "Hochsee + Flug" },
    { value: "R", label: "Fluss" },
    { value: "KOMBI", label: "Hochsee + Hotel + Flug" },
  ];

  if (Array.isArray(data?.type))
    types = types.filter((e) => data.type.includes(e.value));
  React.useEffect(() => {
    if (startSearch) {
      //console.log(selectedRegion);
      searchCruises();
    }
  }, [startSearch]);

  React.useEffect(() => {
    if (
      parsed.region ||
      parsed.type ||
      parsed.t ||
      parsed.red ||
      parsed.shipid ||
      parsed.sdt ||
      parsed.bdt ||
      parsed.cruise_id ||
      parsed.hmi ||
      parsed.dsi ||
      parsed.pageid ||
      parsed.dur ||
      parsed.sort
    ) {
      if (parsed.region && Array.isArray(data.region)) {
        setSelectedRegion(
          [...data.region]
            .filter((e) => {
              return parsed.region.split(",").includes(e.region + "");
            })
            .map((e) => {
              return { ...e, label: e.name, value: e.region };
            })
        );
      }
      if (parsed.sort) {
        setSort(sort);
      }
      if (parsed.dur) {
        setDur(dur);
      }
      if (parsed.type) {
        setSelectedType(types.find((e) => parsed.type === e.value));
      }
      if (parsed.t) {
        setSelectedType(types.find((e) => parsed.t === e.value));
      }
      if (parsed.red && Array.isArray(data.red)) {
        setSelectedShippingCompany(
          [...data.red]
            .filter((e) => {
              parsed.red.split(",").includes(e.red + "");
            })
            .map((e) => {
              return { ...e, label: e.name, value: e.red };
            })
        );
      }

      if (parsed.shipid && Array.isArray(data.shipid)) {
        setSelectedShip(
          [...data.shipid]
            .filter((e) => {
              parsed.shipid.split(",").includes(e.shipid + "");
            })
            .map((e) => {
              return { ...e, label: e.name, value: e.shipid };
            })
        );
      }

      if (parsed.sdt) {
        setSdat(
          parsed.sdt.split(".")[2] +
            "-" +
            parsed.sdt.split(".")[1] +
            "-" +
            parsed.sdt.split(".")[0]
        );
        let day = moment(parsed.sdt, "DD.MM.YYYY");
        setSdatDate(day.toDate());
      }

      if (parsed.bdt) {
        setBdat(
          parsed.bdt.split(".")[2] +
            "-" +
            parsed.bdt.split(".")[1] +
            "-" +
            parsed.bdt.split(".")[0]
        );
        let day = moment(parsed.bdt, "DD.MM.YYYY");
        setBdatDate(day.toDate());
      }
      if (parsed.pageid) {
        setP(parsed.pageid);
      }
      if (parsed.cruise_id) {
        setCruiseid(parsed.cruise_id);
      }
      if (parsed.hmi) {
        if (Array.isArray(parsed.hmi)) setHmi(parsed.hmi);
        else setHmi([parsed.hmi]);
      }
      if (parsed.dsi) {
        if (Array.isArray(parsed.dsi)) setDsi(parsed.dsi);
        else setDsi([parsed.dsi]);
      }
      setTimeout(() => {
        setStartSearch(true);
      }, 200);
    }
  }, [data]);

  React.useEffect(() => {
    fetch(getHost() + "/cruiseparameter?ref=" + window.configData.REF)
      .then((response) => {
        if (response.ok) {
          return response.json();
        }
        throw new Error("Something went wrong");
      })
      .then((responseJson) => {
        setData(responseJson);
        console.log(responseJson);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  const showString = (input) => {
    let output = "";
    if (input.length > 0) {
      for (let i = 0; i < input.length; i++) {
        output = output + "<span>" + input[i].label + ",<br/></span>";
      }
    }

    return output;
  };

  const searchCruises = () => {
    let sep = window.configData.CRUISEURL.indexOf("?") > -1 ? "&" : "?";
    let params = sep + "p=" + p;
    let search = { typ: "cruise" };

    if (sort) {
      params = params + "&sort" + sort;
    }
    if (dur) {
      params = params + "&dur" + dur;
    }
    if (cruiseid) {
      params = params + "&cruise_id=" + cruiseid;
    }
    if (hmi.length > 0) {
      search.hmi = hmi.map((e) => e.value).join(",");
      params = params + "&hmi=" + hmi.join(",");
    }
    if (dsi.length > 0) {
      search.dsi = dsi.map((e) => e.value).join(",");
      params = params + "&dsi=" + dsi.join(",");
    }
    if (selectedRegion.length > 0) {
      search.region = selectedRegion.map((e) => e.value).join(",");

      params =
        params + "&region=" + selectedRegion.map((e) => e.value).join(",");
    }
    if (selectedType?.value) {
      search.type = selectedType.value;
      params = params + "&type=" + selectedType.value;
    }
    if (selectedShippingCompany.length > 0) {
      search.shippingcompany = selectedShippingCompany
        .map((e) => e.value)
        .join(",");
      params =
        params +
        "&red=" +
        selectedShippingCompany.map((e) => e.value).join(",");
    }
    if (selectedShip.length > 0) {
      search.shipid = selectedShip.map((e) => e.value).join(",");
      params = params + "&shipid=" + selectedShip.map((e) => e.value).join(",");
    }

    if (sdatDate) {
      search.sdt =
        (sdatDate.getDate() > 9 ? "" : "0") +
        sdatDate.getDate() +
        "." +
        (sdatDate.getMonth() > 9 ? "" : "0") +
        (sdatDate.getMonth() + 1) +
        "." +
        sdatDate.getFullYear();
      params =
        params +
        "&sdt=" +
        (sdatDate.getDate() > 9 ? "" : "0") +
        sdatDate.getDate() +
        "." +
        (sdatDate.getMonth() > 9 ? "" : "0") +
        (sdatDate.getMonth() + 1) +
        "." +
        sdatDate.getFullYear();
    }
    if (bdatDate) {
      search.bdt =
        (bdatDate.getDate() > 9 ? "" : "0") +
        bdatDate.getDate() +
        "." +
        (bdatDate.getMonth() > 9 ? "" : "0") +
        (bdatDate.getMonth() + 1) +
        "." +
        bdatDate.getFullYear();
      params =
        params +
        "&bdt=" +
        (bdatDate.getDate() > 9 ? "" : "0") +
        bdatDate.getDate() +
        "." +
        (bdatDate.getMonth() > 9 ? "" : "0") +
        (bdatDate.getMonth() + 1) +
        "." +
        bdatDate.getFullYear();
    }

    fetch(getHost() + "/cruisesearch", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        ...search,
        agencyid: window.configData.AGENCYID,
        url: window.configData.CRUISEURL + params,
      }),
    })
      .then((response) => {
        if (response.ok) {
          return response.json();
        }
        throw new Error("Something went wrong");
      })
      .then((responseJson) => {})
      .catch((error) => {
        console.log(error);
      });

    document
      .getElementById("xtibe")
      .setAttribute("src", window.configData.CRUISEURL + params);
    setP("2");
    setCruiseid("");
    setHmi([]);
    setDsi([]);
    setSearchVisible(false);
    if (!window.configData.preventteaserhide) {
      let divs = document.querySelectorAll('[id^="cruiseteaser-"]');
      for (let i = 0; i < divs.length; i++) {
        divs[i].style.display = "none";
      }
    }
    if (!window.configData.preventsearchhide) {
      if (document.getElementById("root")) {
        document.getElementById("root").style.display = "none";
      }
    }
    setTimeout(() => {
      let element = document.getElementById("xtibe");
      let position = element.getBoundingClientRect();
      let x = position.left;
      let y = position.top;
      window.scrollTo(0, y);
    }, 50);
  };

  //(selectedShippingCompany);

  return (
    <div className="App">
      <header
        className="cruise1"
        style={{
          minHeight: searchVisible ? "10vh" : "2vh",
        }}
      >
        {searchVisible && (
          <>
            <div className="cruise2">
              <div className="cruise3">
                <div className="cruise4">Zielgebiet</div>
                <InfoPopupHover
                  trigger={
                    <div>
                      <SelectPopup
                        trigger={
                          <div>
                            <Select
                              styles={{
                                valueContainer: (base, state) => ({
                                  ...base,
                                  textOverflow: "ellipsis",
                                  maxWidth: "90%",
                                  flexWrap: "nowrap",
                                  whiteSpace: "nowrap",
                                  overflow: "hidden",
                                }),
                                multiValue: (base, state) => ({
                                  ...base,
                                  minWidth: "50%",
                                }),
                              }}
                              menuIsOpen={false}
                              options={
                                data?.region
                                  ? [...data.region]
                                      .filter((e) =>
                                        Array.isArray(selectedRegion) &&
                                        selectedRegion.length > 0
                                          ? e.type === selectedRegion[0].type
                                          : true
                                      )
                                      .map((e) => {
                                        return {
                                          ...e,
                                          label: e.name,
                                          value: e.region,
                                        };
                                      })
                                  : []
                              }
                              placeholder={"Zielgebiet auswählen"}
                              value={
                                Array.isArray(selectedRegion)
                                  ? selectedRegion
                                  : []
                              }
                              isMulti
                              onChange={(val) => {
                                setSelectedRegion(val);
                                if (val.length > 0) {
                                  if (val[0].type === "R") {
                                    if (
                                      selectedType?.value &&
                                      selectedType?.value !== "R"
                                    ) {
                                      setSelectedType(defaultRiverCruise);
                                    }
                                  }
                                  if (val[0].type !== "R") {
                                    if (
                                      selectedType?.value &&
                                      selectedType?.value === "R"
                                    ) {
                                      setSelectedType(defaultCruise);
                                    }
                                  }
                                }
                              }}
                            />
                          </div>
                        }
                        content={
                          <div>
                            <OptionDisplay
                              handleChange={setSelectedRegion}
                              handleType={setSelectedType}
                              values={selectedRegion}
                              selectedType={selectedType}
                              options={
                                data?.region
                                  ? [...data.region]
                                      .filter((e) =>
                                        Array.isArray(selectedRegion) &&
                                        selectedRegion.length > 0
                                          ? e.type === selectedRegion[0].type
                                          : true
                                      )
                                      .map((e) => {
                                        return {
                                          ...e,
                                          label: e.name,
                                          value: e.region,
                                        };
                                      })
                                  : []
                              }
                            ></OptionDisplay>
                          </div>
                        }
                        position={"bottom left"}
                      ></SelectPopup>
                    </div>
                  }
                  content={
                    selectedRegion.length !== 0
                      ? showString(selectedRegion)
                      : "Wählen Sie Ihr Reiseziel"
                  }
                  position={"right center"}
                ></InfoPopupHover>
                {/*<Select
                      options={
                        data?.region
                          ? [...data.region]
                              .filter((e) =>
                                Array.isArray(selectedRegion) &&
                                selectedRegion.length > 0
                                  ? e.type === selectedRegion[0].type
                                  : true
                              )
                              .map((e) => {
                                return { ...e, label: e.name, value: e.region };
                              })
                          : []
                      }
                      placeholder={"Zielgebiet auswählen"}
                      value={selectedRegion}
                      isMulti
                      onChange={(val) => {
                        console.log(val);
                        setSelectedRegion(val);
                        if (val.length > 0) {
                          if (val[0].type === "R") {
                            if (
                              selectedType?.value &&
                              selectedType?.value !== "R"
                            ) {
                              setSelectedType(defaultRiverCruise);
                            }
                          }
                          if (val[0].type !== "R") {
                            if (
                              selectedType?.value &&
                              selectedType?.value === "R"
                            ) {
                              setSelectedType(defaultCruise);
                            }
                          }
                        }
                      }}
                    />*/}
              </div>
              <div className="cruise3">
                <div className="cruise4">Reiseart</div>
                <Select
                  styles={{
                    valueContainer: (base, state) => ({
                      ...base,
                      textOverflow: "ellipsis",
                      maxWidth: "90%",
                      flexWrap: "nowrap",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                    }),
                    multiValue: (base, state) => ({ ...base, minWidth: "50%" }),
                  }}
                  options={[...types].filter((e) =>
                    Array.isArray(selectedRegion) && selectedRegion.length > 0
                      ? (selectedRegion[0].type === "R" && e.value === "R") ||
                        (selectedRegion[0].type !== "R" && e.value !== "R")
                      : true
                  )}
                  placeholder={"Reiseart auswählen"}
                  value={selectedType}
                  onChange={(val) => {
                    console.log(val);
                    setSelectedType(val);
                  }}
                />
              </div>
              <div className="cruise3">
                <div className="cruise4">Reederei</div>
                <InfoPopupHover
                  trigger={
                    <div>
                      <SelectPopup
                        trigger={
                          <div>
                            <Select
                              styles={{
                                valueContainer: (base, state) => ({
                                  ...base,
                                  textOverflow: "ellipsis",
                                  maxWidth: "90%",
                                  flexWrap: "nowrap",
                                  whiteSpace: "nowrap",
                                  overflow: "hidden",
                                }),
                                multiValue: (base, state) => ({
                                  ...base,
                                  minWidth: "50%",
                                }),
                              }}
                              menuIsOpen={false}
                              options={
                                data?.red
                                  ? [...data.red]
                                      .filter((e) =>
                                        Array.isArray(selectedRegion) &&
                                        selectedRegion.length > 0
                                          ? (!e.river &&
                                              selectedRegion[0].type === "K") ||
                                            (e.river &&
                                              selectedRegion[0].type === "R")
                                          : true
                                      )
                                      .map((e) => {
                                        return {
                                          ...e,
                                          label: e.name,
                                          value: e.red,
                                        };
                                      })
                                  : []
                              }
                              placeholder={"Reederei auswählen"}
                              value={
                                Array.isArray(selectedShippingCompany)
                                  ? selectedShippingCompany
                                  : []
                              }
                              isMulti
                              onChange={(val) => {
                                setSelectedShippingCompany(val);
                              }}
                            />
                          </div>
                        }
                        content={
                          <div>
                            <ShippingDisplay
                              handleChange={setSelectedShippingCompany}
                              values={selectedShippingCompany}
                              selectedType={selectedType}
                              options={
                                data?.red
                                  ? [...data.red]
                                      .filter((e) =>
                                        Array.isArray(selectedRegion) &&
                                        selectedRegion.length > 0
                                          ? (!e.river &&
                                              selectedRegion[0].type === "K") ||
                                            (e.river &&
                                              selectedRegion[0].type === "R")
                                          : true
                                      )
                                      .map((e) => {
                                        return {
                                          ...e,
                                          label: e.name,
                                          value: e.red,
                                        };
                                      })
                                  : []
                              }
                            ></ShippingDisplay>
                          </div>
                        }
                        position={"bottom center"}
                      ></SelectPopup>
                    </div>
                  }
                  content={
                    selectedShippingCompany.length !== 0
                      ? showString(selectedShippingCompany)
                      : "Wählen Sie die gewünschten Reedereien"
                  }
                  position={"right center"}
                ></InfoPopupHover>

                {/*<Select
                  options={
                    data?.red
                      ? [...data.red]
                          .filter((e) =>
                            Array.isArray(selectedRegion) &&
                            selectedRegion.length > 0
                              ? (!e.river && selectedRegion[0].type === "K") ||
                                (e.river && selectedRegion[0].type === "R")
                              : true
                          )
                          .map((e) => {
                            return { ...e, label: e.name, value: e.red };
                          })
                      : []
                  }
                  placeholder={"Reederei auswählen"}
                  value={selectedShippingCompany}
                  isMulti
                  onChange={(val) => {
                    setSelectedShippingCompany(val);
                  }}
                />*/}
              </div>

              {(selectedType.value === "S" ||
                selectedType.value === "KOMBI") && (
                <div className="cruise3">
                  <div className="cruise4">Abflughafen</div>
                  <InfoPopupHover
                    trigger={
                      <div>
                        <SelectPopup
                          trigger={
                            <div>
                              <Select
                                styles={{
                                  valueContainer: (base, state) => ({
                                    ...base,
                                    textOverflow: "ellipsis",
                                    maxWidth: "90%",
                                    flexWrap: "nowrap",
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                  }),
                                  multiValue: (base, state) => ({
                                    ...base,
                                    minWidth: "50%",
                                  }),
                                }}
                                menuIsOpen={false}
                                options={
                                  data?.hmi
                                    ? [...data.hmi].map((e) => {
                                        return {
                                          ...e,
                                          label: e.name,
                                          value: e.hmi,
                                        };
                                      })
                                    : []
                                }
                                placeholder={"Abflughafen auswählen"}
                                value={Array.isArray(hmi) ? hmi : []}
                                isMulti
                                onChange={(val) => {
                                  setHmi(val);
                                }}
                              />
                            </div>
                          }
                          content={
                            <div>
                              <FlightDisplay
                                handleChange={setHmi}
                                values={hmi}
                                options={
                                  data?.hmi
                                    ? [...data.hmi].map((e) => {
                                        return {
                                          ...e,
                                          label: e.name,
                                          value: e.hmi,
                                        };
                                      })
                                    : []
                                }
                              ></FlightDisplay>
                            </div>
                          }
                          position={"bottom center"}
                        ></SelectPopup>
                      </div>
                    }
                    content={
                      hmi.length !== 0
                        ? showString(hmi)
                        : "Wählen Sie die gewünschten Abflughäfen"
                    }
                    position={"right center"}
                  ></InfoPopupHover>
                </div>
              )}
            </div>
            <div className="cruise2">
              <div className="cruise3">
                <div className="cruise4">Schiff</div>
                <InfoPopupHover
                  trigger={
                    <div>
                      <SelectPopup
                        trigger={
                          <div>
                            <Select
                              styles={{
                                valueContainer: (base, state) => ({
                                  ...base,
                                  textOverflow: "ellipsis",
                                  maxWidth: "90%",
                                  flexWrap: "nowrap",
                                  whiteSpace: "nowrap",
                                  overflow: "hidden",
                                }),
                                multiValue: (base, state) => ({
                                  ...base,
                                  minWidth: "50%",
                                }),
                              }}
                              menuIsOpen={false}
                              options={
                                data?.shipid
                                  ? [...data.shipid]
                                      .filter((e) => {
                                        if (
                                          Array.isArray(
                                            selectedShippingCompany
                                          ) &&
                                          selectedShippingCompany.length > 0
                                        ) {
                                          for (
                                            let i = 0;
                                            i < selectedShippingCompany.length;
                                            i++
                                          ) {
                                            if (
                                              e.red ===
                                              selectedShippingCompany[i].red
                                            ) {
                                              
                                              return true;
                                            }
                                          }
                                          return false;
                                        } else if (
                                          Array.isArray(selectedRegion) &&
                                          selectedRegion.length > 0
                                        ) {
                                          return (
                                            e.type === selectedRegion[0].type
                                          );
                                        } else {
                                          return true;
                                        }
                                      })
                                      .map((e) => {
                                        
                                        return {
                                          ...e,
                                          label: e.name,
                                          value: e.shipid,
                                        };
                                      })
                                  : []
                              }
                              placeholder={"Schiff auswählen"}
                              value={
                                Array.isArray(selectedShip) ? selectedShip : []
                              }
                              isMulti
                              onChange={(val) => {
                                setSelectedShip(val);
                              }}
                            />
                          </div>
                        }
                        content={
                          <div>
                            <ShipDisplay
                              handleChange={setSelectedShip}
                              values={selectedShip}
                              options={
                                data?.shipid
                                  ? [...data.shipid]
                                      .filter((e) => {
                                        if (
                                          Array.isArray(
                                            selectedShippingCompany
                                          ) &&
                                          selectedShippingCompany.length > 0
                                        ) {
                                          for (
                                            let i = 0;
                                            i < selectedShippingCompany.length;
                                            i++
                                          ) {
                                            if (
                                              e.red ===
                                              selectedShippingCompany[i].red
                                            ) {
                                              return true;
                                            }
                                          }
                                          return false;
                                        } else if (
                                          Array.isArray(selectedRegion) &&
                                          selectedRegion.length > 0
                                        ) {
                                          return (
                                            e.type === selectedRegion[0].type
                                          );
                                        } else {
                                          return true;
                                        }
                                      })
                                      .map((e) => {
                                        return {
                                          ...e,
                                          label: e.name,
                                          value: e.shipid,
                                        };
                                      })
                                  : []
                              }
                            ></ShipDisplay>
                          </div>
                        }
                        position={"bottom left"}
                      ></SelectPopup>
                    </div>
                  }
                  content={
                    selectedShip.length !== 0
                      ? showString(selectedShip)
                      : "Wählen Sie die gewünschten Schiffe"
                  }
                  position={"right center"}
                ></InfoPopupHover>

                {/*<Select
                  options={
                    data?.shipid
                      ? [...data.shipid]
                          .filter((e) =>
                            Array.isArray(selectedShippingCompany) &&
                            selectedShippingCompany.length > 0
                              ? e.red === selectedShippingCompany[0].red
                              : Array.isArray(selectedRegion) &&
                                selectedRegion.length > 0
                              ? e.type === selectedRegion[0].type
                              : true
                          )
                          .map((e) => {
                            return { ...e, label: e.name, value: e.shipid };
                          })
                      : []
                  }
                  placeholder={"Schiff auswählen"}
                  value={selectedShip}
                  isMulti
                  onChange={(val) => {
                    setSelectedShip(val);
                  }}
                />*/}
              </div>
              <div className="cruise3">
                <div className="cruise4">Früheste Hinreise</div>

                <input
                  value={sdat}
                  type="date"
                  className="cruise13"
                  onChange={(e) => {
                    setSdat(e.target.value);
                    setSdatDate(e.target.valueAsDate);
                    if (!bdat){
                      let tmpdate = new Date(e.target.value);
                      let tmpdate2 = new Date(tmpdate.setDate(tmpdate.getDate() + 7))
                      setBdatDate(tmpdate2);
                      setBdat(""+tmpdate2.getFullYear()+"-"+(tmpdate2.getMonth()<9?"0":"")+(tmpdate2.getMonth()+1)+"-"+(tmpdate2.getDate()<10?"0":"")+tmpdate2.getDate());
                      

                      //setBdat(e.target.value);
                      //setBdatDate(e.target.valueAsDate);
                    }

                  }}
                  id="sdat"
                ></input>
              </div>
              <div className="cruise3">
                <div className="cruise4">Späteste Rückreise</div>

                <input
                  value={bdat}
                  type="date"
                  className="cruise16"
                  onChange={(e) => {
                    setBdat(e.target.value);
                    setBdatDate(e.target.valueAsDate);
                  }}
                  id="bdat"
                ></input>
              </div>
              <div className="cruise19" onClick={() => searchCruises()}>
                <span>Suchen</span>
              </div>
            </div>
          </>
        )}
        {!searchVisible && (
          <div className="cruise20">
            <div className="cruise21"></div>
            <div className="cruise22" onClick={() => setSearchVisible(true)}>
              <span>Suche anzeigen</span>
            </div>
          </div>
        )}
      </header>
      {/*      <SelectPopup
        trigger={<div style={{ width: "23%" }}>test</div>}
        content={
          <div>
            <OptionDisplay
              options={
                data?.region
                  ? [...data.region]
                      .filter((e) =>
                        Array.isArray(selectedRegion) &&
                        selectedRegion.length > 0
                          ? e.type === selectedRegion[0].type
                          : true
                      )
                      .map((e) => {
                        return { ...e, label: e.name, value: e.region };
                      })
                  : []
              }
            ></OptionDisplay>
          </div>
        }
        position={"bottom center"}
      ></SelectPopup>*/}
    </div>
  );
}

export default App;
